// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 573) return "static/chunks/b5f2ed29-3da110b54d7758d9.js";
	if (chunkId === 353) return "static/chunks/353-addf5925eda96093.js";
	if (chunkId === 499) return "static/chunks/499-7a916ec54647b1c4.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"31":"af36f58e2401f870","154":"36e58baf6b48c69c","298":"8c17b6c9ea90d057"}[chunkId] + ".js";
};